import { Injectable } from '@angular/core';
import { FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NumeroriConstanst } from '@core/globals/numerori/numerori-constants';
import { NumeroriBazaForCreationDTO } from '@core/interfaces/dto/creation/numerori-baza-for-creation-dto.interface';
import { NumeroriForCreationDTO } from '@core/interfaces/dto/creation/numerori-for-creation-dto.interface';
import { NumeroriBazaForUpdateDTO } from '@core/interfaces/dto/update/numerori-baza-for-update-dto.interface';
import { NumeroriBaza } from '@core/interfaces/models/numerori-baza.interface';
import { Subject } from 'rxjs';
import { EditorService } from '../editor.service';
import { NumeroriBazaService } from './numerori-baza.service';
import { NumeroriService } from './numerori.service';

@Injectable({
  providedIn: 'root'
})
export class NumeroriEditorService {

  constructor(private fb: UntypedFormBuilder, private numeroriService: NumeroriService) { }

  getNumeroriBazaForm(form: FormGroup) {
    if (form.get('numeroriBaza')) {
      return <UntypedFormGroup>form.get('numeroriBaza');
    }
    form.addControl(
      'numeroriBaza',
      this.fb.group({
        id: null,
        bazaId: null,
        kategoriaId: null,
        numerori: this.fb.array([]),
        // initialNumerori: this.fb.array([]),
        // formulaNumerori: this.fb.array([]),
      })
    );

    this.numeroriService.generateForms(form.get('numeroriBaza.numerori') as FormArray);

    return form.get('numeroriBaza') as FormGroup;
  }

  generateFormula(baza: string, numeroriBaza: NumeroriBaza, form: FormGroup) {
    this.numeroriService.generateFormula(baza, numeroriBaza, form);
  }


  private _refreshPipes$: Subject<void> = new Subject<void>();

  onRefreshPipe() {
    return this._refreshPipes$.asObservable();
  }

  generateNumeroriForms(formArray: UntypedFormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const nll of NumeroriConstanst.NumeroriLloji) {
      for (const nsh of NumeroriConstanst.NumeroriShoqerimi) {
        for (const ngj of NumeroriConstanst.NumeroriGjinia) {
          for (const nr of NumeroriConstanst.NumeroriRasa) {
            const numeroriForm = this.fb.group({
              llojiId: nll.id,
              shoqerimiId: nsh.id,
              gjiniaId: ngj.id,
              rasaId: nr.id
            });

            formArray.push(numeroriForm);
          }
        }
      }
    }

  }

  getNumeroriBazaDTO(form: FormGroup, baza: string) {
    // const baza = this.editorService.getBaza().getRawValue();
    const numeroriBaza = this.getNumeroriBazaForm(form).getRawValue();

    let formulas = NumeroriConstanst.GetFormulas(baza, numeroriBaza.kategoriaId);

    let numerori: string | undefined = '';
    if (numeroriBaza.kategoriaId == 15 || numeroriBaza.kategoriaId == 16 || numeroriBaza.kategoriaId == 18) {
      numerori = formulas.N2;
    } else if (numeroriBaza.kategoriaId == 17) {
      numerori = formulas.N3;
    }

    const numeroriBazaForCreationDTO: NumeroriBazaForCreationDTO = {
      id: numeroriBaza.id,
      kategoriaId: numeroriBaza.kategoriaId,
      numerori: (numeroriBaza.kategoriaId >= 15 && numeroriBaza.kategoriaId <= 18) ? numerori : '',
      numri: 21
    };
    return numeroriBazaForCreationDTO;

  }

  insertNumeroriBazaIntoEditor(numeroriBaza: NumeroriBaza, form: FormGroup, manual: boolean) {

    this.resetNumeroriBaza(form);

    this.getNumeroriBazaForm(form).patchValue({
      id: numeroriBaza.id,
      bazaId: numeroriBaza.bazaId,
      kategoriaId: numeroriBaza.kategoriaId
    });

    const formArray = this.getNumeroriBazaForm(form).get('numerori') as UntypedFormArray;


    // this.generateNumeroriForms(formArray)

    numeroriBaza.numerori?.forEach((numerori) => {
      formArray.push(
        this.fb.group({
          id: numerori.id,
          numeroriBazaId: numerori.numeroriBazaId,
          pershkrimi: numerori.pershkrimi,
          gjiniaId: numerori.gjiniaId,
          shoqerimiId: numerori.shoqerimiId,
          llojiId: numerori.llojiId,
          rasaId: numerori.rasaId
        })
      );
    });

    formArray.disable();

    form.markAsPristine();
  }

  private resetNumeroriBaza(form: FormGroup) {
    this.getNumeroriBazaForm(form).reset({
      id: null,
      bazaId: null,
      kategoriaId: null,
    });

    Object.keys(this.getNumeroriBazaForm(form).controls)
      .filter((c) => c.toLowerCase().includes('numerori'))
      .flatMap((field) => {
        return this.getNumeroriBazaForm(form).get(field) as UntypedFormArray;
      })
      .forEach((formArray) => {
        while (formArray.controls.length > 0) {
          formArray.removeAt(0);
        }
      });
  }
}
